import { Injectable } from '@angular/core';

export interface EnergyDataFilter {
  municipalityKey: string;
  searchParam: string;
  pageIndex: number | 1;
  pageSize: number | 7;
  sort: string;
  meterTypes: string[];
  energyTypes: string[];
  serialNumbers: string[];
  marketOperators: string[];
  connectionOjectNumber: string;
  maxRowCount: number;
}

@Injectable({
  providedIn: 'root',
})
export class EnergyDataStoreService {
  private _filter: EnergyDataFilter = {
    municipalityKey: '',
    searchParam: '',
    pageIndex: 1,
    pageSize: 7,
    sort: '',
    meterTypes: [],
    energyTypes: [],
    serialNumbers: [],
    marketOperators: [],
    connectionOjectNumber: '',
    maxRowCount: 0,
  };

  public filter = this._filter;

  reset() {
    return {
      municipalityKey: '',
      searchParam: '',
      pageIndex: 1,
      pageSize: 7,
      sort: '',
      meterTypes: [],
      energyTypes: [],
      serialNumbers: [],
      marketOperators: [],
      connectionOjectNumber: '',
      maxRowCount: 0,
    } as EnergyDataFilter;
  }
}
